import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { QuestionImage } from '../shared';

// MultipleChoiceQuizコンポーネント
const MultipleChoiceQuiz = ({ question, answered, isTimeUp, handleSubmit, quickAnswerMode }) => {
  const [selectedOption, setSelectedOption] = useState('');

  // フォームの無効化状態を判定
  const isDisabled = answered || isTimeUp;

  // クイック回答モード用の処理
  const handleOptionSelect = (choice) => {
    if (isDisabled) return;
    setSelectedOption(choice);
    
    // クイックモードの場合、選択と同時に回答を送信
    if (quickAnswerMode === 'quick') {
      const isCorrect = choice === question.answer;
      handleSubmit(isCorrect, question.explanation, question.answer, choice);
    }
  };

  // 通常モード用の回答送信処理
  const onSubmit = () => {
    if (isDisabled) return;
    const isCorrect = selectedOption === question.answer;
    handleSubmit(isCorrect, question.explanation, question.answer, selectedOption);
  };

  return (
    <div className={answered ? 'opacity-70' : ''}>
      {/* 画像がある場合は画像を表示、テキストがある場合は併記 */}
      {question.hasImage && question.questionImage ? (
        <div className="mb-4">
          <QuestionImage 
            imageData={question.questionImage} 
            alt="問題画像" 
            className="mb-3"
          />
          {question.question && (
            <h3 className="text-xl font-semibold text-purple-900">{question.question}</h3>
          )}
        </div>
      ) : (
        <h3 className="text-xl font-semibold text-purple-900 mb-4">{question.question}</h3>
      )}
      <div className="flex flex-col gap-2">
        {question.choices.map((choice, index) => (
          <button
            key={index}
            onClick={() => handleOptionSelect(choice)}
            className={`w-full px-4 py-2 rounded 
              ${answered 
                ? 'bg-gray-200 text-gray-500 cursor-not-allowed' 
                : selectedOption === choice 
                  ? 'bg-purple-600 text-white' 
                  : 'bg-purple-100 text-purple-700 hover:bg-purple-200'}`}
            disabled={isDisabled}
            aria-label={`選択肢 ${choice}`}
          >
            {choice}
          </button>
        ))}
      </div>

      {/* 標準モードの場合のみ回答ボタンを表示 */}
      {quickAnswerMode !== 'quick' && (
        <div className="flex justify-end mt-4">
          <button
            onClick={onSubmit}
            className={`px-4 py-2 rounded 
              ${isDisabled ? 'bg-gray-200 text-gray-500 cursor-not-allowed' : 'bg-purple-600 text-white hover:bg-purple-700'}`}
            disabled={isDisabled || selectedOption === ''}
            aria-label="回答を送信するボタン"
          >
            回答する
          </button>
        </div>
      )}
    </div>
  );
};

MultipleChoiceQuiz.propTypes = {
  question: PropTypes.object.isRequired,
  answered: PropTypes.bool.isRequired,
  isTimeUp: PropTypes.bool.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  quickAnswerMode: PropTypes.oneOf(['standard', 'quick']).isRequired,
};

export default MultipleChoiceQuiz; 